import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { defaults, Pie } from 'react-chartjs-2';
import Color from 'color';

//import logo from '../../assets/images/logos/Logo-Color@2x.png';
import logo from '../../assets/images/logos/Bechtel-Logo-650.png';

import { toTitleCase, colorForCategory, getBechtelCategoryComponents, getDimensionIdForTalent, getScoreClassificationInOrderedGroupScores } from '../../util';
import { getOrderedUserStrengthsFromAllScores, getUserDataFromAllUsers } from '../../util/data';
import { introForPlanYourCareer, introForPlayToYourStrengths, descriptionForPlayToStrengthsTalent, descriptionForPlayToStrengthsCategory, descriptionForTalentCategoryStrength, descriptionForTalentCategoryWeakness, descriptionForTalent, descriptionForTalentCategory, descriptionForCompetency, descriptionForPlayToStrengthsTalentCategory } from '../../util/bechtelDescriptions';
import { iconForTalentCategory } from '../../util/icons';

let PAGE_OFFSET = 4;

const usersWithCompetitiveAdvantages = {
  "0UX4iC2Ij2aJvtuG57E1": true,
  "0kYHGtnDJ1F5Kvee7Pov": true,
  "1GqTjoHrOX3g1OxAu8Ml": true,
  "1NrR9CGdVqPEjI9GBatV": true,
  "1tGerri8Ll9ZBIuLVbzV": true,
  "295TBSLjmI7QlRFfgUVb": true,
  "2Ul8Dy1syqVB4dhDvG1S": true,
  "4YaPr6qMthZ9oi1Q0fML": false,
  "4yDrgqeM7xMr1eYGrFgl": true,
  "5FcgFpyUDc4R0KBNtayI": false,
  "5ngACbRNNDowonvelLEx": true,
  "61DgHGkZbBOxS47oS7hb": true,
  "61kNPLReGwRbLijA1ye0": true,
  "78mFEdEjK4w10pr4xnwZ": true,
  "7i4DPwM7mEYb4nA0bFXz": false,
  "7uOOV1yvrrwH9NWc09hm": true,
  "918XIDecBB1xmb2LOKAe": true,
  "9NUQ4CKUh28Kcrz6FRZb": true,
  "9wPXz4Ky2LLACZ6g0WdK": true,
  "AAdqQQhAMQfIyNZ8ddrN": true,
  "C6E8NzVSgFHK9pT0zxMa": true,
  "CePETXRqxSqDFcdheAZ9": true,
  "CzLSjsgsPShHr2WJWc44": true,
  "DTvHpcnpcT8Bbwb8g9cE": true,
  "Fl391r0vJy4olhu9S6xP": true,
  "GJBsZcbuKdOo1nTqKv09": true,
  "GwfnpFTcofeky4qO8F1l": false,
  "HIniCXhyMoXwLDyHxesy": true,
  "Ivvpg3jQuE1Xwc8Ik9DB": true,
  "JFb1uQetMOC0SOV6lp4O": true,
  "LDfJFfp4wqS6D6XKoyKH": true,
  "LEAerHeFbkee9LqUL5PD": false,
  "LrPMZ0zRWS2swxXQtGiF": true,
  "NCMMk1MLUpazaJxtgsbt": true,
  "OwKdZm2eyEHRmLRsT6H8": true,
  "P06WjpjRyHZrWGqNfp42": true,
  "PJmNWrm7jPTj3fo40cvn": true,
  "Q2pp2mJLu9YUNae9Jylt": true,
  "Q7xmFaHnRiEeJZgHA2Xg": true,
  "QIp9g8HcudhwqeuVlaH0": false,
  "QQJUMMjvEohKVMM6dBHa": true,
  "RXweOBj01hYNowKLwbJO": true,
  "RlPvovBlzBhLGtGuzM4l": true,
  "S5EP0xna2rm88n3zAsrP": true,
  "SAqAragJHosflccS3xwB": true,
  "Sp063EsoUUa3nL9YiLMK": false,
  "T9fcyK8qyoDsFEkz6p7V": false,
  "TY6RQNwQ9iGbt3vHCgNN": true,
  "Toib77ztJMBwOlvMw6Tv": false,
  "Vx9jcJr5coRexSiaRVRD": true,
  "W7IXqT89xpPUNxDed71h": true,
  "cEIKWQ8ZacIZ9ZL9AvQl": true,
  "dsCc6fe05zfTxbIyUMuR": false,
  "eI5PHXWJzi5FbvdHQBZK": true,
  "ebVU66qUQ7PU3f9e2aUZ": false,
  "evnEbRaEyu4cO9mdTVqr": true,
  "g2JTAPT7rV4My5oMuKCu": false,
  "g5N0GgPUdDTg04Oaohcf": true,
  "gubc7bzuEZfaAkz3CO0Y": true,
  "hRQaAplKzq4czgNAkJ1b": true,
  "htmFc7Kth8s5nEMxTf0F": true,
  "i4r6lQk5cFAp4UIcoAEW": true,
  "iOhZabXarcgBj4IlS1sa": true,
  "iekQ5b90nbeKI9FQpqtE": true,
  "isO7wOPK03Gd9zZyfA4k": true,
  "iuJfUzmcJ6Zx9wFXvDbk": false,
  "jK4zQWyLXjKV4yQZ9lJP": true,
  "jyZWGTZDd2k5JUcW0Lkd": true,
  "k9gfONo4iPE82eP9GM16": true,
  "lF4ggPhBSBTU8zbC8fLA": false,
  "lUSkw955od8LctH1qGJK": true,
  "mranD3HELZXabpWkFRMu": true,
  "nJa0mnZHJ9rj9FYgp7Wy": true,
  "ndyGOS4EorE38H6DoXQv": true,
  "nhAzUv0lKR1mwTLUzsTz": true,
  "nspQCwNN9dXNar9VrIQw": true,
  "nszr0uikNWWGdDr9QtYm": true,
  "nwmdoGlu0VhNiXR7dEtl": true,
  "pUXd8OF9gvSqBafIUpQn": false,
  "qCvzLk49pmEnbzvyiGZM": true,
  "qO45DovpZoQ8FvA6eltA": true,
  "qvYFirDzPdWejIx07bn7": false,
  "r42d4NH0W08jqVXBp7PI": true,
  "raqIVhbUbweZ6GCKDtEE": false,
  "sSOklkn4O7m8AAUc3rYD": false,
  "tZFpnTqYQKZyJBhTfoZO": true,
  "urIkwpwCq3P8Mgh81xkM": true,
  "v3pRtlxOjcC08V35qsl1": true,
  "wLii2AXveA9jT09XCz5p": true,
  "wTB2jirnuKv3AILyH0hY": true,
  "yFxIJc4qtlX8sFPk5AoB": false,
  "yPO7OlogBWfdPHROJwzt": true
}

//const LOGO_WIDTH = "150";
//const LOGO_HEIGHT = "40";
const LOGO_WIDTH = "50";
const LOGO_HEIGHT = "50";

// Disable animating charts by default.
defaults.pie.animation.animateRotate = false;
defaults.pie.animation.animateScale = false;
defaults.global.tooltips.enabled = false;
//defaults.global.elements.arc.borderWidth = 0;
defaults.global.elements.arc.backgroundColor = 'rgba(0,0,0,.1)';

const TALENT_CATEGORIES=[{
  name: 'Motivation',
  id: 'motivation'
},{
  name: 'Interaction',
  id: 'interaction'
},{
  name: 'Execution',
  id: 'execution'
},{
  name: 'Cognition',
  id: 'cognition'
}];

class BechtelReport extends Component {

  state = {
    ProfileID: null
  }

  componentWillMount(){
    const { match: { params } } = this.props;

    this.setState({
      ProfileID: params.ProfileID
    });

    //pages offset by one less if no CA report
    if(usersWithCompetitiveAdvantages[params.ProfileID]){
      PAGE_OFFSET = 4;
    }
    else{
      PAGE_OFFSET = 3;
    }
  }
  componentDidMount(){
    console.log('bechtel report props: ', this.props);
  }

  renderLoadingMessage(){
    return <p>Loading...</p>;
  }

  dataForProfile(){

    const ProfileID = this.state.ProfileID;

    console.log(`data for profile ${ProfileID} calculating...`);

    const userData = _.find(this.props.users, {_id: ProfileID} );

    console.log('userData: ', userData);

    if(!userData){
      return null;
    }

    const strengths = getOrderedUserStrengthsFromAllScores(userData);

    console.log('strengths: ', strengths);

    if(!strengths){
      return null;
    }

    return {
      user: userData,
      strengths: strengths,
    }
  }

  componentWillReceiveProps(nextProps){
    console.log('bechtel report page nextProps: ', nextProps);
  }

  renderPieChart(chartData){
    return <Pie legend={{display:false}} ref='chart' options={{maintainAspectRatio:false}} data={chartData} />
  }

  orderedTalentCategories(){
    const strengthScores = this.dataForProfile().strengths;

    return strengthScores;
  }

  chartDataForCategory(category = 'all'){

    if(category === 'all'){
      const orderedTalentCategories = this.orderedTalentCategories();

      return {
        datasets: [{
          data: _.map(orderedTalentCategories, 'percent'),
          backgroundColor: _.map(_.map(orderedTalentCategories, 'id'), colorForCategory)
        }]
      }
    }
    else{
      const categoryColor = Color(colorForCategory(category.id));

      return {
        datasets: [{
          data: _.map(category.talents, 'percent'),
          backgroundColor: [categoryColor.rgb().string(), categoryColor.fade(.2).rgb().string(), categoryColor.fade(.4).rgb().string(), categoryColor.fade(.6).rgb().string(), categoryColor.fade(.8).rgb().string()]
        }]
      }
    }
  }

  renderStrengthsScores(){
    const categories = this.orderedTalentCategories();

    return(
      <div className="strengths-scores tall">
        <div className="pie">
          <div className="chart-container">
            {this.renderPieChart(this.chartDataForCategory('all'))}
          </div>
        </div>

        {_.map(categories, category => {

          const categoryScoreClassification = getScoreClassificationInOrderedGroupScores(category.percent, _.map(categories, 'percent'));

          return (
            <div key={category.id} className={`strength ${category.id}`}>
              <div className="name">{category.name}</div>
              <div className="percent" style={{color: colorForCategory(category.id)}}>{Math.round(category.percent)}%</div>
              {categoryScoreClassification === 'high' &&
                <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Strong Category</div>
              }
              {categoryScoreClassification === 'low' &&
                <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Weak Category</div>
              }
            </div>
          );
        })}
      </div>
    )
  }

  renderScoresForCategory(category){

    //console.log('renderScoresForCategory: ', category);

    return(
      <div className={`strengths-scores ${category.talents.length === 3 ? 'three-wide' : ''}${category.talents.length === 5 ? 'five-wide' : ''} tall`}>
        <div className="pie">
          <div className="chart-container">
            {this.renderPieChart(this.chartDataForCategory(category))}
          </div>
        </div>

        {_.map(category.talents, (talent, index) => {

          const talentScoreClassification = getScoreClassificationInOrderedGroupScores(talent.percent, _.map(category.talents, 'percent'));

          return (
            <div key={talent.name} className={`strength ${talent.name}`}>
              <div className="name">{talent.name}</div>
              <div className="percent">{Math.round(talent.percent)}%</div>
                {talentScoreClassification === 'high' &&
                  <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Strong Talent</div>
                }
                {talentScoreClassification === 'low' &&
                  <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Weak Talent</div>
                }
            </div>
          );
        })}
      </div>
    )
  }

  renderSingleScorePie(percentage, color){
    const dataForPie = {
      datasets: [{
        data: [percentage, (100 - percentage)],
        backgroundColor: [color,'rgba(0,0,0,.1)'],
      }]
    }

    return <Pie legend={{display:false}} ref='chart' options={{maintainAspectRatio:false}} data={dataForPie} />
  }

  getScoreLabel(score, isCategory, scoreClassification = false){

    const roundedScore = Math.round(score);

    if(!scoreClassification){
      return roundedScore + '%';
    }
    else if(scoreClassification === 'high'){
      return roundedScore + '% - Strong ' + (isCategory ? 'category' : 'talent');
    }
    else if(scoreClassification === 'low'){
      return roundedScore + '% - Weak ' + (isCategory ? 'category' : 'talent');
    }
    else{
      return roundedScore + '%';
    }
  }

  renderTalentCategories(){

    const categories = this.orderedTalentCategories();
    const dataForProfile = this.dataForProfile();

    if(!dataForProfile){
      return null;
    }

    return(
      <div className="talents">
        {_.map(categories, (category, index) => {

          const categoryScoreClassification = getScoreClassificationInOrderedGroupScores(category.percent, _.map(categories, 'percent'));
          const categoryTalents = getBechtelCategoryComponents(category.id, dataForProfile.user["Job Role"]);
          const categoryTalentsAsString = _.reduce(categoryTalents, function(memo, talent, index){
            if(index > 0){
              return memo + ', ' + toTitleCase(talent);
            }
            else{
              return toTitleCase(talent);
            }
          }, '');

          return (
            <div key={'category-definition-' + category.id} className="talent">
              <div className="talent-summary">
                <div className="talent-name">{category.name}</div>
                <div className="chart-container">
                  {this.renderSingleScorePie(category.percent, colorForCategory(category.id))}
                </div>
                <div className="percent" style={{color: colorForCategory(category.id)}}>{this.getScoreLabel(category.percent, true, categoryScoreClassification)}</div>
              </div>
              <div className="talent-info">
                <p>{descriptionForTalentCategory(category.id)}</p>
                {categoryScoreClassification === 'high' &&
                  <p>{descriptionForTalentCategoryStrength(category.id)}</p>
                }
                {categoryScoreClassification === 'low' &&
                  <p>{descriptionForTalentCategoryWeakness(category.id)}</p>
                }
                <p className="competency">&gt; &nbsp;Predictive {category.name} Business Development Talents: {categoryTalentsAsString}</p>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  renderTalentsForCategory(category){
    return(
      <div className="talents">
        {_.map(category.talents, talent => {

          const talentScoreClassification = getScoreClassificationInOrderedGroupScores(talent.percent, _.map(category.talents, 'percent'));

          return (
            <div key={'category-definition-' + talent.id} className="talent">
              <div className="talent-summary">
                <div className="talent-name">{talent.name}</div>
                <div className="chart-container">
                  {this.renderSingleScorePie(talent.percent, colorForCategory(category.id))}
                </div>
                <div className="percent" style={{color: colorForCategory(category.id)}}>{this.getScoreLabel(talent.percent, false, talentScoreClassification)}</div>
              </div>
              <div className="talent-info">
                <p>{descriptionForTalent(talent.id)}</p>
                <p className="competency">&gt; &nbsp;Competency: {descriptionForCompetency(talent.id)}</p>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  renderFooterForPage(pageNumber){
    return (
      <div className="page-footer">
        {this.renderPreparedForUser()}
        {this.renderPageNumber(pageNumber)}
      </div>
    )
  }

  renderPreparedForUser(){
    const dataForProfile = this.dataForProfile();

    const {FirstName, LastName} = dataForProfile.user;

    return (
      <div className="prepared-for">Prepared for {FirstName} {LastName}</div>
    )
  }

  renderPageNumber(number){
    return (
      <div className="page-marker">Page {number}</div>
    )
  }

  renderCategoryPage(category, index){
    return (
      <div key={'page-' + category.id} className="report-know-your-strengths report-page">
        <img className="report-logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} src={logo} />
        <h2>{category.name} Talents</h2>
        {this.renderScoresForCategory(category)}
        {this.renderTalentsForCategory(category)}
        {this.renderFooterForPage(index + 2 + PAGE_OFFSET)}
      </div>
    )
  }

  renderPlayToYourStrengthsReport(dataForProfile){

    const orderedTalentCategories = this.orderedTalentCategories();

    return (
      <template>
        <div className="page report-export">
          <div className="report-play-to-your-strengths report-page">
            <img className="report-logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} src={logo} />
            <h1>Play To Your Strengths<br/><span className="prepared-for" style={{textTransform: 'capitalize'}}>{dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</span></h1>
            <div className="report-section" style={{paddingTop: '0px'}} dangerouslySetInnerHTML={{__html: introForPlanYourCareer()}}></div>
            <div className="report-section full-width-with-icon">
              <div className="section-icon">{iconForTalentCategory(orderedTalentCategories[0].id)}</div>
              <div className="section-title">Your leading VELOCITY.win category: {orderedTalentCategories[0].name}</div>
              <div className="section-content large-font" dangerouslySetInnerHTML={{__html: descriptionForPlayToStrengthsTalentCategory(orderedTalentCategories[0].id)}}></div>
            </div>
            <div className="report-section no-bottom-border">
              <p>The next page will break down your top talent in each core area of impact. These are strengths that you draw upon to deliver in each core area of impact. Based on your responses to the talent inventory the following strategies have been custom created for you, based on your leading talent for each core area...</p>
            </div>
            {dataForProfile && this.renderFooterForPage(6 + PAGE_OFFSET)}
          </div>
        </div>

        <div className="page report-export">
          <div className="report-play-to-your-strengths report-page">
            <img className="report-logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} src={logo} />
            <h1>Play To Your Strengths<br/><small className="prepared-for" style={{textTransform: 'capitalize'}}>{dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</small></h1>

            {_.map(orderedTalentCategories, (talentCategory, index) => {
              return (
                <div key={'top-talent-definition-for-category-' + talentCategory.id} className={'report-section has-icon ' + (index === 3 ? 'no-bottom-border' : '')}>
                  <div className="section-icon">{iconForTalentCategory(talentCategory.id)}</div>
                  <div className="section-title">Top {talentCategory.name} Talent: {talentCategory.talents[0].name}</div>
                  <div className="section-content" dangerouslySetInnerHTML={{__html: descriptionForPlayToStrengthsTalent(talentCategory.talents[0].id)}}></div>
                </div>
              );
            })}
            {dataForProfile && this.renderFooterForPage(7 + PAGE_OFFSET)}
          </div>
        </div>
      </template>
    )
  }

  renderKnowYourStrengthsReport(dataForProfile){
    return (
      <div className="page report-export">
        <div className="report-know-your-strengths report-page">
          <img className="report-logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} src={logo} />
          <h1>Know Your Strengths<br/><span className="prepared-for" style={{textTransform: 'capitalize'}}>{dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</span></h1>
          {dataForProfile && this.renderStrengthsScores()}
          {dataForProfile && this.renderTalentCategories()}
          {dataForProfile && this.renderFooterForPage(1 + PAGE_OFFSET)}
        </div>

        {dataForProfile && _.map(this.orderedTalentCategories(), this.renderCategoryPage.bind(this))}

        {!dataForProfile && this.renderLoadingMessage()}
      </div>
    )
  }

  render(){

    const dataForProfile = this.dataForProfile();

    console.log('main render');
    console.log('users: ', this.props.users);
    console.log('dataForProfile: ', dataForProfile);

    if(!dataForProfile || !dataForProfile.user){
      return null;
    }

    return (
      <div>
        {this.renderKnowYourStrengthsReport(dataForProfile)}
        {this.renderPlayToYourStrengthsReport(dataForProfile)}
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    users: state.users,
  }
}

export default connect(mapStateToProps, {})(BechtelReport);



// WEBPACK FOOTER //
// ./src/components/report_deprecated/bechtel.js